class ServerApi extends EventTarget {
    constructor() {
        super();
    }

    setEndpoint(endPoint) {
        this.endPoint = endPoint;
        this.email = null;
        this.password = null;
    }

    fileUrl(token) {
        return this.endPoint + '/file/?token=' + token;
    }

    async fileToken(file) {
        return await this.post(this.endPoint + '/filetoken/?file=' + encodeURIComponent(file), {
            auth: {
                email: this.email,
                password: this.password
            }
        });
    }

    async onDeck() {
        return await this.post(this.endPoint + '/library/deck', {
            auth: {
                email: this.email,
                password: this.password
            }
        });
    }

    async episodes(key) {
        return await this.post(this.endPoint + '/library/shows/?season=' + encodeURIComponent(key), {
            auth: {
                email: this.email,
                password: this.password
            }
        });
    }

    async seasons(key) {
        return await this.post(this.endPoint + '/library/shows/?show=' + encodeURIComponent(key), {
            auth: {
                email: this.email,
                password: this.password,
            }
        });
    }

    async shows() {
        return await this.post(this.endPoint + '/library/shows/', {auth: {email: this.email, password: this.password}});
    }

    imageUrl(url) {
        return this.endPoint + '/library/image?image=' + url.replace('/library/metadata/', '');
    }

    async auth(email, password) {
        console.log("Auth with", this.endPoint, email, password);
        let result = await this.post(this.endPoint + '/auth', {auth: {email, password}});
        if (result === true) {
            this.email = email;
            this.password = password;
            this.dispatchEvent(new Event('authenticated'));
        } else {
            localStorage.removeItem('auth');
            location.reload()
        }
        return result;
    }

    async post(endPoint, body) {
        return await this.json(endPoint, {
            method: 'POST',
            body: JSON.stringify(body),
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async get(endPoint) {
        return await this.json(endPoint, {
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async json(endPoint, options) {
        let response = await fetch(endPoint, options);
        let text = await response.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            console.warn("Could not parse server response", text);
            return false;
        }
    }
}

export default new ServerApi();